import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider, Select } from 'antd';
import InputSelectField from '../../../../../components/mobile/form-helpers/InputSelectField';
import HeaderScreening from '../../../../../components/mobile/sign-up/HeaderScreening';
import SharedWithList from '../../../../../components/mobile/medical-history/SharedWithList';
import { FormInputArea } from '../../../../../components/mobile/form-helpers/FormField';

const { Title } = Typography;

const data = [
  {label: 'Selection 1', value: 'Selection 1'},
  {label: 'Selection 2', value: 'Selection 2'},
  {label: 'Selection 3', value: 'Selection 3'},
  {label: 'Selection 4', value: 'Selection 4'},
]

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  }
}

function MobileFamilyHistoryScreen({fieldName, step, count}) {
  const { t } = useTranslation(['medical-history', 'common']);
  const history = useHistory();
  const { values, setFieldValue } = useFormikContext();
  const [lists, setLists] = useState(values[fieldName]);

  const handleChange = (name, val) => {
    const data = {label: val, value: val};
    const arr = [...lists, data];
    setLists(arr);
    setFieldValue(fieldName, arr);
  }

  const onRemove = (val) => {
    const arr = lists.filter(function(obj) {
      return obj.value !== val;
    });
    setLists(arr);
    setFieldValue(fieldName, arr);
  }

  return (
    <>
      <HeaderScreening
        count={count}
        step={step}
        title={t('medical-history:familyHistory.title')}
        subtitle={t('medical-history:familyHistory.subtitle')}
      />
      <Divider />
      <Col xs={24}>
        <FormInputArea
          name={fieldName}
          style={{ width: '100%', padding: '3%' }}
          formItemLayout={formItemLayout}
          onChange={(e) => setFieldValue(fieldName, e.target.value)}
          value={values[fieldName]}
          rows={6}
        />
        {/* <InputSelectField
          name="temp_family_history"
          label={t('medical-history:familyHistory.form.enterFamilyHistory.label')}
          placeholder={t('medical-history:familyHistory.form.enterFamilyHistory.placeholder')}
          options={data}
          handleChange={handleChange}
        />
        <Box>
          <SharedWithList
            title={t('medical-history:familyHistory.form.yourFamilyHistory.label')}
            emptyTitle={t('medical-history:familyHistory.form.yourFamilyHistory.noSelected')}
            list={lists}
            onRemove={onRemove} />
        </Box> */}
      </Col>
    </>
  );
}

export default MobileFamilyHistoryScreen;
